<template>
  <div class="bigbox">
    <div class="contain_test">
      <div></div>
      <div class="contain_test_top">
        <h3>直播设备检测</h3>
        <div class="el-icon-close" @click="closethis"></div>
      </div>
      <div class="contain_test_content">
        <div class="left">
          <video style="height:100%;width:100%;" id="videomedia"></video>
        </div>
        <div class="right">
          <div class="camera">
            <h4>摄像头</h4>
            <el-select v-model="cameraId" placeholder="请选择" @change="playVideo">
              <el-option
                v-for="item in cameraEquiDatas"
                :key="item.deviceId"
                :label="item.label"
                :value="item.deviceId"
              ></el-option>
            </el-select>
          </div>
          <div class="microphone">
            <h4>麦克风</h4>
            <el-select v-model="microphoneId" placeholder="请选择">
              <el-option
                v-for="item in microphoneQquidatas"
                :key="item.value"
                :label="item.label"
                :value="item.deviceId"
              ></el-option>
            </el-select>
          </div>
          <!-- <div class="loudspeaker">
            <h4>扬声器</h4>
            <el-select v-model="speakerId" placeholder="请选择">
              <el-option
                v-for="item in speakersDatas"
                :key="item.value"
                :label="item.label"
                :value="item.deviceId"
              ></el-option>
            </el-select>
          </div>-->
        </div>
      </div>
      <div class="contain_test_btn" @click="requestbtn">确认</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cameraEquiDatas", "microphoneQquidatas", "speakersDatas",'microphoneIds','cameraIds'],
  data() {
    return {
      optionOne: [],
      optionTwo: [],
      cameraId: "",
      microphoneId: "",
      speakerId: ""
    };
  },
  mounted() {
    this.cameraId = this.cameraIds;
    if(this.cameraIds){
      this.playVideo();
    }
    this.microphoneId = this.microphoneIds;
  },
  methods: {
    playVideo() {
      var videoprm = navigator.mediaDevices.getUserMedia({
        audio: true,
        video: { deviceId: this.cameraId }
      });
      videoprm.then(res => {
        this.playbox(res);
      });
      videoprm.catch(rej => {
        this.$message({
          message: "该摄像头有在其他地方使用中，请停止在尝试",
          type: "warning"
        });
      });
    },
    playbox(stream) {
      var video = document.querySelector("#videomedia");
      // video.srcObject = res;
      // video.src = window.URL.createObjectURL(srcObject);
      try {
        video.srcObject = stream;
      } catch (error) {
        video.src = window.URL.createObjectURL(stream);
      }
      video.onloadedmetadata = function(e) {
        video.play();
        console.log(e);
      };
    },
    requestbtn() {
      var devices = {
        cameraId: this.cameraId,
        microphoneId: this.microphoneId,

      };
      this.$emit("close_btn", devices);
    },
    closethis() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.bigbox {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
}
.contain_test {
  width: 830px;
  height: 471px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: #fff;
  padding-top: 27px;
  box-sizing: border-box;
  text-align: left;
  .contain_test_top {
    padding-left: 38px;
    position: relative;
    margin-bottom: 47px;
    h3 {
      font-size: 16px;
      font-weight: 500;
      color: #323643;
    }
    div {
      position: absolute;
      top: 0;
      right: 37px;
      font-weight: 700;
      font-size: 18px;
      color: #979797;
    }
  }
  .contain_test_content {
    display: flex;
    align-items: center;
    margin-left: 44px;
    margin-bottom: 35px;
    .left {
      width: 482px;
      height: 271px;
      border: 1px solid #ebebeb;
      box-sizing: border-box;
      margin-right: 20px;
    }
    .right {
      div h4 {
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        color: #585b63;
        margin-bottom: 8px;
      }
      .camera {
        margin-bottom: 20px;
      }
      .microphone {
        margin-bottom: 20px;
      }
    }
    div ::v-deep .el-select .el-input.is-focus .el-input__inner:focus {
      border-color: #07d1aa;
    }
    div ::v-deep .el-select .el-input__inner:focus {
      border-color: #07d1aa;
    }

    div ::v-deep .el-select .el-input.is-focus .el-input__inner {
      border-color: #07d1aa;
    }
  }
  .contain_test_btn {
    text-align: center;
    width: 165px;
    height: 35px;
    line-height: 35px;
    background: #07d1aa;
    border-radius: 4px;
    font-size: 16px;
    color: #ffffff;
    margin: 0 auto;
    cursor: pointer;
  }
}
.el-select-dropdown .el-scrollbar .selected {
  color: #07d1aa;
}
.el-icon-close {
  cursor: pointer;
}
</style>